/* eslint-disable */
import PopUpModal from '../../../components/common/popup';
import InputField from '../../../components/common/input-field';
import './../text-editor/style.scss';
import Switch from '@mui/material/Switch';
import AutoCompleteSelect from '../../../components/common/selectAutoComplete';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import checkoutService from '../../api/checkoutService';
import { AxiosInstance } from 'axios';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { QuillEditor } from '../../../components/common/quill-editor/quill-editor';
import PreviewProduct from './PreviewProduct';
import { UploadIcon } from '../../../assets/icons/upload';
import ImagePopup from '../../../components/common/image-selector/image-popup';
import { showNotification } from '../../api/constant';
import { paddingProps } from '../../puck/reusable-props/padding';

export interface IProductModalProps {
  productDetails: {
    id: string;
    name: string;
    imageUrl: string;
    price: number;
    variantid: number;
    label: string;
  };
  order: number;
  addAlias: boolean;
  aliasName: string;
  aliasImageUrl: string;
  totalCartPrice: string;
  defaultProduct: boolean;
  isDisplayPrice: boolean;
  displayPrice: string;
  isTag: boolean;
  tagText: string;
  highlightColor: string;
  isHighlight: boolean;
  configId: null | number;
}

export const defaultProduct: IProductModalProps = {
  productDetails: {
    id: '',
    name: '',
    label: '',
    imageUrl: '',
    price: 0,
    variantid: 0,
  },
  order: 1,
  addAlias: false,
  aliasName: '',
  aliasImageUrl: '',
  totalCartPrice: '',
  defaultProduct: false,
  isDisplayPrice: false,
  displayPrice: '',
  isTag: true,
  tagText: '',
  highlightColor: '#FEC500',
  isHighlight: false,
  configId: null,
};

export interface ProductModalProps {
  value: IProductModalProps[];
  onChange: (_value: IProductModalProps[]) => void;
  baseService: AxiosInstance;
}

const ProductModal: React.FC<ProductModalProps> = ({
  value,
  onChange,
  baseService,
}) => {
  const [productModal, setProductModal] = useState(false);
  const [imagePopup, setimagePopup] = useState('');
  const [mode, setMode] = useState('design');
  const [searchParams] = useSearchParams();
  const [duplicateValue, setDuplicateValue] = useState(value);

  const storeID = searchParams.get('storeID') || '';
  const pageID = searchParams.get('pageID') || '';

  useEffect(() => {
    (async () => {
      try {
        const response = await checkoutService.getAllFunnelishConfig(
          +storeID,
          baseService,
          +pageID,
        );
        const products = [];
        for (const element of response?.data?.productDetails) {
          const name = element?.variants?.[0]?.productVariants?.label;
          const variantid = element?.variants?.[0]?.productVariants?.value;
          const productId = element?.assignedProducts?.value;
          const imageUrl =
            element?.variants?.[0]?.productVariants?.productImage;
          const price = element?.variants?.[0]?.totalUpSellPrice;
          products.push({
            productDetails: {
              id: element?.id,
              name,
              label: `${name} ($${price}) (${productId})`,
              imageUrl,
              price,
              variantid,
            },
            order: products.length + 1,
            addAlias: false,
            aliasName: '',
            aliasImageUrl: '',
            totalCartPrice: price,
            defaultProduct: false,
            isDisplayPrice: false,
            displayPrice: '',
            isTag: true,
            tagText: '',
            highlightColor: '#FEC500',
            isHighlight: false,
            configId: null,
          });
        }
        setDuplicateValue(products);
      } catch (error) {
        console.error('Error fetching Funnelish config:', error);
      }
    })();
  }, []);

  return (
    <>
      <ToggleButtonGroup
        value={mode}
        exclusive
        className="w-full"
        onChange={(_, value) => {
          setMode(value);
          if (value === 'products') {
            setProductModal(true);
          } else {
            setProductModal(false);
          }
        }}
        aria-label="mode">
        <ToggleButton
          value="design"
          className="w-1/2"
          sx={{
            '&.Mui-selected': {
              backgroundColor: '#F90182',
              color: '#fff',
            },
          }}>
          Design
        </ToggleButton>
        <ToggleButton
          value="products"
          className="w-1/2"
          sx={{
            '&.Mui-selected': {
              backgroundColor: '#F90182',
              color: '#fff',
            },
          }}>
          Products
        </ToggleButton>
      </ToggleButtonGroup>
      <PopUpModal
        heading="Product Configuration"
        open={productModal}
        boxClassName="!w-full !max-w-[1500px]"
        handleClose={() => {
          setProductModal(!productModal);
          setMode('design');
          setDuplicateValue(value);
        }}
        buttons={[
          {
            buttonType: 'negative',
            buttonLabel: 'Close',
            buttonFunction: () => {
              setProductModal(!productModal);
              setMode('design');
              setDuplicateValue(value);
            },
          },
          {
            buttonType: 'positive',
            buttonLabel:
              value?.length !== duplicateValue?.length ? 'Add' : 'update',
            disabled: false,
            buttonFunction: () => {
              const duplicateSelected = duplicateValue?.filter(
                item => item.defaultProduct,
              );
              if (duplicateSelected?.length > 1) {
                showNotification(
                  'failed',
                  'Only one product can be selected as default.',
                );
              } else {
                onChange(duplicateValue);
                setProductModal(false);
                setMode('design');
              }
            },
          },
        ]}>
        <div>
          <div className="grid grid-cols-2 gap-4 mt-4">
            {duplicateValue?.map((product, index) => {
              return (
                <div
                  className="grid grid-cols-2 border-2 !border-gray-600 rounded-2xl text-white max-w-4xl mx-auto"
                  key={index}>
                  <div className="col-span-2 flex items-center justify-between">
                    <div className="gap-4 p-3 flex items-center w-full">
                      <div className="font-medium text-xs whitespace-nowrap">
                        Add Shopify Product:
                      </div>
                      <AutoCompleteSelect
                        disabled={true}
                        selectClassName="w-full"
                        options={[]}
                        labelKey="label"
                        customHeight="40px"
                        onChange={e => {}}
                        placeholder="Select products"
                        value={
                          product?.productDetails?.label
                            ? {
                                label: product?.productDetails?.label,
                                value: -product?.productDetails?.id,
                              }
                            : null
                        }
                      />
                    </div>
                  </div>

                  <div className="col-span-2 grid grid-cols-4 border-y-2 !border-gray-600 h-16">
                    <label className="text-xs font-medium flex items-center justify-around gap-2 px-2">
                      Order:
                      <InputField
                        className="pagebuilder-theme h-9"
                        value={product?.order}
                        onChange={e => {
                          if (!isNaN(+e)) {
                            const updatedValue = duplicateValue.map(
                              (item, i) =>
                                i === index ? { ...item, order: +e } : item,
                            );
                            setDuplicateValue(updatedValue);
                          }
                        }}
                      />
                    </label>
                    <div className="text-xs font-medium border-x-2 !border-gray-600 flex items-center justify-around gap-2 px-2">
                      <span>Add Alias:</span>
                      <Switch
                        onChange={e => {
                          const updatedValue = duplicateValue?.map((item, i) =>
                            i === index
                              ? { ...item, addAlias: e.target.checked }
                              : item,
                          );

                          setDuplicateValue(updatedValue);
                        }}
                        disabled={true}
                        checked={product?.addAlias}
                        sx={{
                          '& .MuiSwitch-thumb': {
                            backgroundColor: product?.addAlias
                              ? 'green'
                              : 'red',
                          },
                          '& .MuiSwitch-track': {
                            backgroundColor: product?.addAlias
                              ? 'green'
                              : 'red',
                          },
                        }}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    </div>
                    {product.addAlias && (
                      <>
                        <label className="text-xs font-medium border-r-2 !border-gray-600 flex items-center justify-around gap-2 px-2">
                          Name:
                          <InputField
                            className="pagebuilder-theme h-9"
                            value={product?.aliasName}
                            onChange={aliasName => {
                              const updatedValue = duplicateValue?.map(
                                (item, i) =>
                                  i === index ? { ...item, aliasName } : item,
                              );
                              setDuplicateValue(updatedValue);
                            }}
                          />
                        </label>
                        <div className="text-xs font-medium flex items-center justify-around gap-2 px-2">
                          <span>Image:</span>
                          {product?.aliasImageUrl ? (
                            <div className="relative group w-[50px] h-[50px]">
                              <img
                                src={`${process.env.REACT_APP_S3_BUCKET_URL}${product.aliasImageUrl}`}
                                alt="Preview"
                                width={50}
                                height={50}
                                className="object-cover rounded"
                              />
                              <button
                                className="absolute top-0 right-0 w-5 h-5 bg-red-500 hover:bg-red-600 text-white rounded-full text-sm font-bold shadow-md transition-opacity opacity-0 group-hover:opacity-100"
                                onClick={() => {
                                  const updatedValue = duplicateValue?.map(
                                    (item, i) =>
                                      i === index
                                        ? { ...item, aliasImageUrl: '' }
                                        : item,
                                  );
                                  setDuplicateValue(updatedValue);
                                }}>
                                -
                              </button>
                            </div>
                          ) : (
                            <button
                              onClick={() => setimagePopup(String(index))}>
                              <UploadIcon />
                            </button>
                          )}
                          {String(index) === imagePopup && (
                            <ImagePopup
                              setPopupOpen={() => setimagePopup('')}
                              customId={`predefined-component${product.order}`}
                              handleSubmit={selectedImage => {
                                const updatedValue = duplicateValue?.map(
                                  (item, i) =>
                                    i === index
                                      ? {
                                          ...item,
                                          aliasImageUrl: selectedImage.imageUrl,
                                        }
                                      : item,
                                );
                                setDuplicateValue(updatedValue);
                              }}
                              image={{
                                imageUrl: '',
                                fileName: '',
                                storeID: '',
                              }}
                              isPopupOpen={!!imagePopup}
                              baseService={baseService}
                            />
                          )}
                        </div>
                      </>
                    )}
                  </div>

                  <div className="col-span-2 grid grid-cols-2 border-b-2 !border-gray-600 h-16">
                    <label className="font-medium text-xs border-r-2 !border-gray-600 flex items-center justify-center gap-2 px-2">
                      Total Cart Price:
                      <InputField
                        value={product?.totalCartPrice}
                        isPrefixText="$"
                        disabled={true}
                        className="pagebuilder-theme h-9"
                        onChange={e => {
                          const regex = /^\d+(\.\d{0,2})?$/;
                          const isNumber = regex.test(e);

                          if (isNumber || e === '') {
                            const updatedValue = duplicateValue?.map(
                              (item, i) =>
                                i === index
                                  ? { ...item, totalCartPrice: e }
                                  : item,
                            );
                            setDuplicateValue(updatedValue);
                          }
                        }}
                      />
                    </label>
                    <div className="text-xs font-medium flex items-center justify-center gap-2 px-2">
                      <span>Default Selected:</span>
                      <Switch
                        onChange={e => {
                          const updatedValue = duplicateValue?.map((item, i) =>
                            i === index
                              ? { ...item, defaultProduct: e.target.checked }
                              : item,
                          );
                          setDuplicateValue(updatedValue);
                        }}
                        checked={product?.defaultProduct}
                        sx={{
                          '& .MuiSwitch-thumb': {
                            backgroundColor: product?.defaultProduct
                              ? 'green'
                              : 'red',
                          },
                          '& .MuiSwitch-track': {
                            backgroundColor: product?.defaultProduct
                              ? 'green'
                              : 'red',
                          },
                        }}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    </div>
                  </div>
                  <div className="col-span-2 grid grid-cols-3 border-b-2 !border-gray-600 h-12">
                    <div className="text-xs font-medium flex items-center gap-2 px-2">
                      <span>Displayed Price:</span>
                      <Switch
                        onChange={e => {
                          const updatedValue = duplicateValue?.map((item, i) =>
                            i === index
                              ? { ...item, isDisplayPrice: e.target.checked }
                              : item,
                          );
                          setDuplicateValue(updatedValue);
                        }}
                        checked={product?.isDisplayPrice}
                        sx={{
                          '& .MuiSwitch-thumb': {
                            backgroundColor: product?.isDisplayPrice
                              ? 'green'
                              : 'red',
                          },
                          '& .MuiSwitch-track': {
                            backgroundColor: product?.isDisplayPrice
                              ? 'green'
                              : 'red',
                          },
                        }}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    </div>
                    <div className="text-xs font-medium flex items-center gap-2 px-2 border-x-2 !border-gray-600">
                      <span>Add Tag:</span>
                      <Switch
                        onChange={e => {
                          const updatedValue = duplicateValue?.map((item, i) =>
                            i === index
                              ? { ...item, isTag: e.target.checked }
                              : item,
                          );
                          setDuplicateValue(updatedValue);
                        }}
                        checked={product?.isTag}
                        sx={{
                          '& .MuiSwitch-thumb': {
                            backgroundColor: product?.isTag ? 'green' : 'red',
                          },
                          '& .MuiSwitch-track': {
                            backgroundColor: product?.isTag ? 'green' : 'red',
                          },
                        }}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    </div>
                    <div className="text-xs font-medium flex items-center gap-2 px-2">
                      <span>Highlight:</span>
                      <Switch
                        onChange={e => {
                          const updatedValue = duplicateValue?.map((item, i) =>
                            i === index
                              ? { ...item, isHighlight: e.target.checked }
                              : item,
                          );
                          setDuplicateValue(updatedValue);
                        }}
                        checked={product?.isHighlight}
                        sx={{
                          '& .MuiSwitch-thumb': {
                            backgroundColor: product?.isHighlight
                              ? 'green'
                              : 'red',
                          },
                          '& .MuiSwitch-track': {
                            backgroundColor: product?.isHighlight
                              ? 'green'
                              : 'red',
                          },
                        }}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    </div>
                  </div>
                  <div className="col-span-2 grid grid-cols-3">
                    <div>
                      {product.isDisplayPrice && (
                        <QuillEditor
                          value={product.displayPrice}
                          enableLink={false}
                          onChange={e => {
                            const updatedValue = duplicateValue?.map(
                              (item, i) =>
                                i === index
                                  ? { ...item, displayPrice: e }
                                  : item,
                            );
                            setDuplicateValue(updatedValue);
                          }}
                          id={index * 2 + 1}
                        />
                      )}
                    </div>
                    <div className="border-x-2 !border-gray-600">
                      {product.isTag && (
                        <QuillEditor
                          value={product.tagText}
                          enableLink={false}
                          onChange={e => {
                            const updatedValue = duplicateValue?.map(
                              (item, i) =>
                                i === index ? { ...item, tagText: e } : item,
                            );
                            setDuplicateValue(updatedValue);
                          }}
                          id={index * 2 + 2}
                        />
                      )}
                    </div>
                    <div>
                      <div className="text-xs font-medium flex items-center pt-2 px-2 gap-2">
                        {product.isHighlight && (
                          <>
                            <span>Highlight Color:</span>
                            <input
                              type="color"
                              className="pagebuilder-theme h-8"
                              value={product.highlightColor}
                              onChange={e => {
                                const updatedValue = duplicateValue?.map(
                                  (item, i) =>
                                    i === index
                                      ? {
                                          ...item,
                                          highlightColor: e.target.value,
                                        }
                                      : item,
                                );
                                setDuplicateValue(updatedValue);
                              }}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="mx-auto bg-[#1F2937] rounded-md grid justify-center py-4 w-[400px] mt-4">
            <span className="text-white place-self-center pb-2">
              Product Selection Review
            </span>

            <div className="bg-white w-96 p-2 rounded-md">
              <div className="flex justify-between text-sm font-medium mb-2">
                <span>Product</span>
                <span>Price</span>
              </div>

              <hr className="border-t-2 border-gray-300 mb-2" />
              <div className="grid grid-cols-1 gap-3">
                <PreviewProduct
                  data={duplicateValue}
                  maxContainerWidth="100%"
                  tagPosition="top"
                  borderForProducts={{
                    deviceType: 'desktop',
                    borderBottomLeft: {
                      desktop: '10',
                      tablet: '10',
                      mobile: '10',
                    },
                    borderBottomRight: {
                      desktop: '10',
                      tablet: '10',
                      mobile: '10',
                    },
                    borderTopLeft: {
                      desktop: '10',
                      tablet: '10',
                      mobile: '10',
                    },
                    borderTopRight: {
                      desktop: '10',
                      tablet: '10',
                      mobile: '10',
                    },
                    borderTopWidth: {
                      desktop: 1,
                      tablet: 1,
                      mobile: 1,
                    },
                    borderRightWidth: {
                      desktop: 1,
                      tablet: 1,
                      mobile: 1,
                    },
                    borderBottomWidth: {
                      desktop: 1,
                      tablet: 1,
                      mobile: 1,
                    },
                    borderLeftWidth: {
                      desktop: 1,
                      tablet: 1,
                      mobile: 1,
                    },
                    borderWidth: {
                      desktop: 1,
                      tablet: 1,
                      mobile: 1,
                    },
                    borderStyle: {
                      desktop: 'border-solid',
                      tablet: 'border-solid',
                      mobile: 'border-solid',
                    },
                    borderColor: {
                      desktop: '#a3a3a3',
                      tablet: '#a3a3a3',
                      mobile: '#a3a3a3',
                    },
                  }}
                  radioColor="#2563EB"
                  radioSize="20"
                  productTitle={{
                    weight: {
                      mobile: 'font-semibold',
                      tablet: 'font-semibold',
                      desktop: 'font-semibold',
                    },
                    deviceType: 'desktop',
                    text: '',
                    textColor: {
                      mobile: '#000000',
                      tablet: '#000000',
                      desktop: '#000000',
                    },
                    hoverColor: {
                      mobile: '#000000',
                      tablet: '#000000',
                      desktop: '#000000',
                    },
                    fontSize: {
                      mobile: 'text-sm',
                      tablet: 'text-sm',
                      desktop: 'text-sm',
                    },
                  }}
                  currentDeviceType="desktop"
                  pageId={pageID}
                  image={{
                    height: {
                      desktop: '40',
                      mobile: '40',
                      tablet: '40',
                    },
                    maxWidth: {
                      desktop: '40',
                      mobile: '40',
                      tablet: '40',
                    },
                    deviceType: 'desktop',
                  }}
                  tagStyles={{
                    isBlink: 'no',
                    borderTopLeft: '0',
                    borderTopRight: '0',
                    borderBottomLeft: '0',
                    borderBottomRight: '0',
                    ...paddingProps,
                    backgroundColor: '#FFFFFF',
                  }}
                  selectedProduct={
                    duplicateValue?.find(item => item.defaultProduct)
                      ?.productDetails.id ??
                    (duplicateValue?.[0]?.productDetails.id || '')
                  }
                  setSelectedProduct={() => {}}
                />
              </div>
            </div>
          </div>
        </div>
      </PopUpModal>
    </>
  );
};

export default ProductModal;
